module.exports = __webpack_public_path__ + "static/media/success.a2f981d7.svg";